module.exports = __webpack_public_path__ + "static/media/ic_check_filled.4eff77ab.svg";